import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { TelemetryService } from './telemetry.service';

/**
 * Catch-all Angular error handler for errors that aren't already handled at a component/service. It sends
 * the error to Application Insights and shows the user an error toast carrying the reference code, so even
 * an unexpected crash gives the user a value to quote to support. Errors handled explicitly (e.g. via
 * {@link ErrorHandlingService}) never reach here, so this doesn't double-toast.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly telemetry = inject(TelemetryService);
  private readonly notify = inject(NotificationService);
  private readonly zone = inject(NgZone);

  handleError(error: any): void {
    console.error(error);

    try {
      const reference = this.telemetry.captureError(error, { source: 'GlobalErrorHandler' });
      // Uncaught errors can fire outside the Angular zone; run inside it so the snackbar renders.
      this.zone.run(() => this.notify.error(undefined, reference));
    } catch (handlerError) {
      // Never let the error handler throw — that would mask the original error.
      console.error('GlobalErrorHandler failed', handlerError);
    }
  }
}
